export { SORT_TYPES } from './sortTypes';

export const TOAST_SALES_COLUMNS = [
  { id: 'business_date', label: 'Business Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'venue_name', label: 'Venue', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'line_count', label: 'Lines', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'net_sales', label: 'Toast Net Sales', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'matched_net_sales', label: 'Matched to Shows', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'unmatched_net_sales', label: 'Unmatched', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'events', label: 'Shows', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'void_total', label: 'Voided', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'currency' },
  { id: 'actions', label: '', alwaysVisible: false, defaultVisible: true, sortable: false },
];

export const getDefaultVisibleColumns = () =>
  TOAST_SALES_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  TOAST_SALES_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
